<template>
    <v-autocomplete
        v-model.trim="from.hosp"
        :auto-select-first="true"
        color="#009688"
        autocomplete="nope"
        return-object
        item-text="hosp_name"
        :items="from.hospItems"
        :rules="[v=>!!v||'Name of Hospital or Clinic is required']"
    >
        <template #label>
            <span style="font-weight: 500; color: black;">Name of Hospital or Clinic</span>
        </template>
    </v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['hosp', 'hospItems'],
    data: ()=>({
        from: {
            hosp: null,
            hospItems: []
        }
    }),
    watch: {
        hosp(newVal) {
            if (newVal) this.from.hosp = newVal
        },
        hospItems(newVal) {
            if (newVal) this.from.hospItems = newVal
        },
        'from.hosp': {
            async handler(newVal) {
                if (newVal) {
                    await this.getHospClinDocData(newVal.hosp_msu_code)
                    this.$emit('setHosp', newVal)
                }
            }
        }
    },
    methods: {
        ...mapActions(['getProviderAffiDoctors', 'toDoctors']),
        async getHospClinDocData(PROVIDER_ID) {
            await this.getProviderAffiDoctors({ PROVIDER_ID })
            // await this.toDoctors({ PTYPE: '', HOSP_MSU: PROVIDER_ID, SPEC: '' })
        }
    }
}
</script>
